<template>
  <div class="img-container" :style="getBorderRadius">
    <div
      class="img-box"
      :style="styleObject"
      ref="imgBox"
      @click.self="imgClickEvent"
      :class="linkUrlLength > 0 ? 'c-pointer' : ''"
    ></div>
    <div
      v-if="options.zoomToView"
      class="zoom-btn icon-portal-zoom-in"
      :style="zoomBtnStyle"
      @click="zoomClickEvent"
    ></div>
    <el-dialog :append-to-body="true" :visible.sync="showImageDialog" custom-class="imageDialog">
      <div class="img-box" :style="bgStyle"></div>
    </el-dialog>
    <el-dialog
      ref="imgZoomBox"
      :append-to-body="true"
      :fullscreen="true"
      :visible.sync="zoomImageDialog"
      custom-class="zoomImageDialog"
      @open="open"
      @close="close"
    >
      <div
        class="zoom-img-box"
        :style="zoomBgStyle"
        @wheel="onWheel"
        @pointerdown="pointerdownEvent"
        @pointermove="pointermoveEvent"
        @pointerup="pointerupEvent"
        @pointercancel="pointercancelEvent"
        @click.stop="stopEvent"
      ></div>
      <div class="zoom-panel" @click.stop="stopEvent">
        <div class="zoom-minus icon-portal-zoom-out" @click="zoomMinus"></div>
        <div class="zoom-text">{{ zoomScale }}%</div>
        <div class="zoom-add icon-portal-zoom-in" @click="zoomAdd"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import defaultImageHome from "assets/images/default_image_home.png"
import defaultImageScreen from "assets/images/default_image_screen.png"
import eventMixin from "utils/event/eventMixin.js"
import plugins from "./plugin"
import { spliceLinkUrl, isExist } from "utils"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, plugins, dataRenderMixin],
  name: "img-component",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      reloadTimer: null,
      defaultImageHome: defaultImageHome,
      defaultImageScreen: defaultImageScreen,
      zoomImageDialog: false,
      zoomScale: 120,
      // 用于鼠标拖拽
      x: 0,
      y: 0,
      isPointerdown: false, // 按下标识
      point: { x: 0, y: 0 }, // 第一个点坐标
      diff: { x: 0, y: 0 }, // 相对于上一次pointermove移动差值
      lastPointermove: { x: 0, y: 0 }, // 用于计算diff
      isFlag: false
    }
  },
  computed: {
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    imgSrc() {
      if (this.options.isUserInfo) {
        return this.getImgData()
      } else {
        if (this.options.imgSrc && this.options.imgSrc.length > 0) {
          if (this.check_is_img(this.options.imgSrc)) {
            return this.options.imgSrc
          } else {
            if (this.isBigScreen) {
              return this.defaultImageScreen
            } else {
              return this.defaultImageHome
            }
          }
        } else {
          if (this.isBigScreen) {
            return this.defaultImageScreen
          } else {
            return this.defaultImageHome
          }
        }
      }
    },
    updateTimer() {
      if (!this.options.updateTimer) {
        this.$changeOptionsEV(600, "updateTimer", false)
        return 600 * 1000
      }
      return this.options.updateTimer * 1000
    },

    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    boxShadowStyle() {
      let tmpStyle = ""
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) tmpStyle += ","
          tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getBorderRadius() {
      return {
        "border-top-left-radius":
          this.options.borderTypeFlag == 1
            ? this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderTopLeftRadius + "px"
            : this.options.shapeType == "round"
            ? this.options.borderRadius
            : this.options.borderRadius + "px",
        "border-top-right-radius":
          this.options.borderTypeFlag == 1
            ? this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderTopRightRadius + "px"
            : this.options.shapeType == "round"
            ? this.options.borderRadius
            : this.options.borderRadius + "px",
        "border-bottom-left-radius":
          this.options.borderTypeFlag == 1
            ? this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderBottomLeftRadius + "px"
            : this.options.shapeType == "round"
            ? this.options.borderRadius
            : this.options.borderRadius + "px",
        "border-bottom-right-radius":
          this.options.borderTypeFlag == 1
            ? this.options.shapeType == "round"
              ? this.options.borderTopLeftRadius
              : this.options.borderBottomRightRadius + "px"
            : this.options.shapeType == "round"
            ? this.options.borderRadius
            : this.options.borderRadius + "px"
      }
    },
    styleObject() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      return {
        ...this.getBorderRadius,
        "border-style": this.options.borderStyle,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor,
        }),
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-width": this.options.showBorder !== false ? borderW : 0,
        "box-shadow": this.boxShadowStyle,
        transform: "rotate(" + this.options.rotate + "deg)",
        "background-image": "url(" + this.imgSrc + ")",
        "background-repeat": this.options.repeatType,
        "background-size": this.options.clipSize,
        "background-position": this.options.alignType,
        opacity: this.options.opacity / 100,
        "background-clip": "content-box"
      }
    },
    hoverTransform() {
      switch (this.options.hoverType) {
        case "imgScale":
          return "scale(1.1)" + " " + "rotate(" + this.options.rotate + "deg)"
        case "leftMove":
          return "rotate(" + this.options.rotate + "deg)" + " " + "translateX(-10px)"
        case "topMove":
          return "rotate(" + this.options.rotate + "deg)" + " " + "translateY(-10px)"
        default:
          return "rotate(" + this.options.rotate + "deg)"
      }
    },
    linkUrlLength() {
      return this.options.linkUrl.length
    },
    bgStyle() {
      return {
        "background-image": "url(" + this.imgSrc + ")",
        "background-repeat": this.options.repeatType,
        "background-size": "contain",
        "background-position": this.options.alignType
      }
    },
    zoomBgStyle() {
      let width = 0,
        height = 0
      if (this.zoomImageDialog) {
        width = this.$refs.imgBox.clientWidth
        height = this.$refs.imgBox.clientHeight
      }
      return {
        ...this.styleObject,
        width: width + "px",
        height: height + "px",
        transform: `${this.styleObject.transform} translate(-50%, -50%) scale3d(${this.zoomScale / 100}, ${
          this.zoomScale / 100
        }, 1)`
      }
    },
    zoomBtnStyle() {
      const zoomPosition = this.options.zoomPosition || "right bottom"
      const position = {}
      zoomPosition.indexOf("right") > -1 ? (position.right = "6px") : (position.left = "6px")
      zoomPosition.indexOf("top") > -1 ? (position.top = "6px") : (position.bottom = "6px")
      return position
    },
    showImageDialog: {
      get() {
        return this.options.showImageDialog
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showImageDialog", false, null, this.myid)
      }
    },
    currentFiledMapping() {
      return this.options.currentFiledMapping || {}
    },
  },
  watch: {
    "options.detailFieldMapping": {
      deep: true,
      handler(n, o) {
        if (n) {
          this.updateData()
        }
      }
    },
    "options.currentFiledMapping": {
      deep: true,
      handler(n, o) {
        if (this.noCacheComponent === "3" && n && n.isChecked) {
          this.setClassifyData()
        }
      }
    },
    "options.emptyDataShowLocal": {
      deep: true,
      handler(n, o) {
        if (this.noCacheComponent) {
          this.updateData()
        }
      }
    },
    "options.emptyImgSrc": {
      deep: true,
      handler(n, o) {
        if (this.options.emptyDataShowLocal && this.options.isEmptyData && this.noCacheComponent) {
          this.$changeOptionsEV(n, "imgSrc", false, null, this.myid)
        }
      }
    },
    imgSrc: {
      handler() {
        this.handleImageCompression()
      }
    },
    "options.clipSize": {
      handler() {
        this.handleImageCompression()
      }
    },
    "options.width": {
      handler() {
        this.handleImageCompression()
      }
    },
    "options.height": {
      handler() {
        this.handleImageCompression()
      }
    },
    "options.compression": {
      handler() {
        this.handleImageCompression()
      }
    },
    noCacheComponent(n, o) {
      if (n !== o && n === "3") {
        if (!this.isFlag) this.watchClassifyData() // 新增监听
        if (this.currentFiledMapping.isChecked) this.setClassifyData() // 获取分类数据
      }
    }
  },
  mounted() {
    this.$initPlugin(this.options?.pluginName)
    if (
      this.noCacheComponent &&
      ((!this.options?.filedMapping?.flag && this.options.appId) || this.options?.detailFieldMapping?.isChecked)
    ) {
      this.updateData()
      if (this.isBigScreenPreview() && this.options.autoUpdate !== false) {
        this.reloadTimer = setInterval(() => this.updateData(), this.updateTimer)
      }
    }
    if (this.noCacheComponent === "3" && (this.options?.detailFieldMapping?.isChecked || this.currentFiledMapping.isChecked)) {
      // 监听列表页分类数据改变
      this.watchClassifyData()
    }
  },
  destroyed() {
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
    this.$eventBus.$off("classifyDetailDataUpdate")
    this.$eventBus.$off(`layout-classify-update-eventBus-${this.myid.container_id}-${this.myid.rect_id}-${this.curLayoutOptions.elementInAutoLayoutId}-${this.curLayoutOptions.path}`)
  },
  methods: {
    watchClassifyData() {
      this.isFlag = true
      if (isExist(this.myid?.directionIndex)) {
        // 监听自由布局内部分类数据
        this.$eventBus.$on(`layout-classify-update-eventBus-${this.myid.container_id}-${this.myid.rect_id}-${this.curLayoutOptions.elementInAutoLayoutId}-${this.curLayoutOptions.path}`, (msg)=> {
          this.setClassifyData(msg.data)
        })
      } else {
        // 监听列表页分类数据
        this.$eventBus.$on("classifyDetailDataUpdate", (data)=> {
          this.updateData()
        })
      }
    },
    async updateData() {
      this.updateNormalRect.call(
        this,
        data => {
          this.$changeOptionsEV(false, "isEmptyData", false, null, this.myid, true)
          let hasData = false 
          if (data && typeof data === "string") {
            this.$changeOptionsEV(data, "imgSrc", false, null, this.myid)
            hasData = true
          } else if (data[0]) {
            this.$changeOptionsEV(data[0][Object.keys(data[0])[0]].value, "imgSrc", false, null, this.myid)
            hasData = true
          }
          if (!hasData) {
            if (this.options.emptyDataShowLocal) {
              this.$changeOptionsEV(this.options.emptyImgSrc, "imgSrc", false, null, this.myid)
            } else {
              this.$changeOptionsEV("", "imgSrc", false, null, this.myid)
            }
            this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
          }
        },
        1
      )
    },
    setClassifyData(data) {
      let curData = data ? data : this.getClassifyData()
      if (!curData) {
        if (this.options.emptyDataShowLocal) {
          this.$changeOptionsEV(this.options.emptyImgSrc, "imgSrc", false, null, this.myid, true)
        } else {
          this.$changeOptionsEV("", "imgSrc", false, null, this.myid, true)
        }
        this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
      }
      if (this.currentFiledMapping && this.currentFiledMapping.fieldFlag && curData) {
        this.$changeOptionsEV(false, "isEmptyData", false, null, this.myid, true)
        const tempData = curData.find(item=>item.value === this.currentFiledMapping.fieldFlag)
        if (tempData) {
          const dataType = this.currentFiledMapping.dataType
          let tempDataValue = tempData.content
          if (dataType === "dataKey") {
            tempDataValue = tempData.label + "：" + tempData.content
          } else if (dataType === "dataName") {
            tempDataValue = tempData.label
          }
          if (this.options.emptyDataShowLocal) {
            tempDataValue = tempData.content ? tempDataValue : this.options.emptyImgSrc
          }
          this.$changeOptionsEV(tempDataValue, "imgSrc", false, null, this.myid, true)
          if (!tempDataValue || (!this.options.emptyDataShowLocal && !tempData.content)) {
            this.$changeOptionsEV(true, "isEmptyData", false, null, this.myid, true)
          }
        }
      }
    },
    getImgData() {
      let defaultPortrait = require("assets/images/default_portrait.png")
      let userInfo = this.$store.state.states.userInfo
      if (userInfo) {
        return userInfo.portrait || defaultPortrait
      }
      this.$API.getUserInfo().then(res => {
        if (res.data.code === 1) {
          let userInfo = {
            portrait: res.data.data.uid ? `https://photo.chaoxing.com/p/${res.data.data.uid}_80` : defaultPortrait,
            ...res.data.data
          }
          this.$store.commit("states/updateUserInfo", userInfo)
          return userInfo.portrait
        }
      })
    },
    imgClickEvent() {
      // showImageDialog 轮播中点击事件是否成功
      if (
        this.myid &&
        this.myid.elementInSwiperId !== null &&
        typeof this.myid.elementInSwiperId !== "undefined" &&
        !this.options.showImageDialog
      ) {
        // 轮播全局设置点击图片放大 不需要了放到轮播中
        // const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.myid, "rect")
        // if (rectAttr && rectAttr.options && rectAttr.options.zoomImage) {
        //   this.showImageDialog = true
        // }
      } else if (this.options.zoomImage) {
        this.showImageDialog = true
      }
      // 预览页面使用
      if (!this.options.linkUrl) {
        return
      }
      if (this.request_prefix === "bigScreen" && !this.isBigScreenPreview()) {
        return
      }
      if (this.request_prefix !== "bigScreen" && !this.isSsrPage()) {
        return
      }
      const spliceUrl = spliceLinkUrl(this)
      if (this.options.openBlankPage) {
        window.open(spliceUrl || this.options.linkUrl, "_blank")
      } else {
        window.location.href = spliceUrl || this.options.linkUrl
      }
    },
    zoomClickEvent() {
      this.zoomScale = 120
      this.zoomImageDialog = true
    },
    check_is_img(url) {
      let ifImgStr = url.match(/\.(jpeg|jpg|gif|png)/)
      let ifImg = true
      if (!ifImgStr) {
        // 排除头像的情况  排除云盘的情况 有些没有后缀的图片地址
        if (
          url.indexOf("photo.chaoxing.com") !== -1 ||
          url.indexOf("engine2/file/download") !== -1 ||
          url.indexOf("p.ananas.chaoxing.com") !== -1 ||
          url.indexOf("https://") !== -1 ||
          url.indexOf("http://") !== -1
        ) {
          ifImg = true
        } else {
          ifImg = false
        }
      }
      return ifImg
    },
    zoomMinus() {
      if (this.zoomScale > 40) {
        this.zoomScale -= 40
      }
    },
    zoomAdd(e) {
      if (this.zoomScale < 500) {
        this.zoomScale += 40
      }
    },
    onWheel(e) {
      if (e.deltaY > 0) {
        this.zoomMinus()
      } else if (e.deltaY < 0) {
        this.zoomAdd()
      }
    },
    open() {
      this.$refs.imgZoomBox.$el.addEventListener("click", this.zoomCloseEvent, false)
    },
    close() {
      this.$refs.imgZoomBox.$el.removeEventListener("click", this.zoomCloseEvent, false)
    },
    zoomCloseEvent() {
      this.zoomImageDialog = false
    },
    // 空函数，用于阻止冒泡
    stopEvent() {},
    pointerdownEvent(e) {
      this.isPointerdown = true
      e.target.setPointerCapture(e.pointerId)
      this.point = { x: e.clientX, y: e.clientY }
      this.lastPointermove = { x: e.clientX, y: e.clientY }
    },
    pointermoveEvent(e) {
      if (this.isPointerdown) {
        const current1 = { x: e.clientX, y: e.clientY }
        this.diff.x = current1.x - this.lastPointermove.x
        this.diff.y = current1.y - this.lastPointermove.y
        this.lastPointermove = { x: current1.x, y: current1.y }
        this.x += this.diff.x
        this.y += this.diff.y
        e.target.style.transform =
          "translate3d(" + this.x + "px, " + this.y + "px, 0) scale(" + this.zoomScale / 100 + ")"
      }
      e.preventDefault()
    },
    pointerupEvent(e) {
      if (this.isPointerdown) {
        this.isPointerdown = false
      }
    },
    pointercancelEvent(e) {
      if (this.isPointerdown) {
        this.isPointerdown = false
      }
    },
    // 云盘资源需要压缩
    handleImageCompression() {
      if (
        /(p.ananas.chaoxing.com\/star3)\/origin|(p.cldisk.com\/star3)\/origin/.test(this.imgSrc) &&
        this.options.compression &&
        this.options.clipSize !== "auto auto" &&
        this.options.clipSize !== "100% 100%"
      ) {
        let img = new Image()
        img.src = this.imgSrc
        img.onload = ev => {
          if (ev.target) {
            const zoom = this.$store.state.states.zoomActual
            let width = ev.target.width
            let height = ev.target.height
            let actualWidth =
              this.options.widthType === "px" ? this.options.width : parseInt(this.$refs.imgBox.clientWidth / zoom)
            let actualHeight =
              this.options.heightType === "px" ? this.options.height : parseInt(this.$refs.imgBox.clientHeight / zoom)
            let originwidth = 0
            let originHeight = 0
            let size = "auto 100%"
            if (this.options.clipSize === "cover") {
              size = width > height ? "auto 100%" : "100% auto"
              if (actualHeight && height && actualWidth / actualHeight >= width / height) {
                size = "100% auto"
              }
            }
            // 尺寸比原图小，再压缩，否则使用原图
            if (size === "auto 100%") {
              if (actualHeight < height) {
                originHeight = actualHeight
                originwidth = parseInt((width / height) * originHeight)
              }
            }
            if (size === "100% auto") {
              if (actualWidth < width) {
                originwidth = actualWidth
                originHeight = parseInt((width / height) * originwidth)
              }
            }
            this.$changeOptionsEV(
              [originwidth, originHeight],
              ["originWidth", "originHeight"],
              false,
              null,
              this.myid,
              true
            )
          }
          img = null
        }
      }
    }
  }
}
</script>

<style scoped>
.img-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.img-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.zoom-img-box {
  position: absolute;
  left: 50%;
  top: 50%;
  cursor: grab;
}
.c-pointer:hover {
  cursor: pointer;
}
.zoom-btn {
  position: absolute;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.3);
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 3px;
}
.zoom-btn:hover {
  cursor: pointer;
}
.zoom-panel {
  width: 108px;
  height: 42px;
  padding: 4px 10px 4px 10px;
  border-radius: 4px;
  background: rgba(70, 81, 100, 1);
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  display: flex;
}
.zoom-minus,
.zoom-add {
  width: 22px;
  height: 34px;
  padding: 10px 4px 10px 4px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  cursor: pointer;
}
.zoom-text {
  width: 44px;
  height: 34px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
}
::v-deep .imageDialog.el-dialog {
  box-shadow: unset;
  background: unset;
  border: unset;
  height: 65%;
}
::v-deep .imageDialog .el-dialog__body {
  border-top: unset;
  border-bottom: unset;
  background: unset;
  height: 100%;
}
::v-deep .imageDialog .el-dialog__header {
  display: none;
}
::v-deep .zoomImageDialog.el-dialog {
  background: unset;
  border: none;
  overflow: hidden;
}
::v-deep .zoomImageDialog.el-dialog .el-dialog__headerbtn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(70, 81, 100, 1);
}
::v-deep .zoomImageDialog.el-dialog .el-dialog__header {
  padding: unset;
}
::v-deep .zoomImageDialog.el-dialog .el-dialog__body {
  background: unset;
  border: none;
  padding: unset;
}
::v-deep .zoomImageDialog.el-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  background: none;
}
::v-deep .zoomImageDialog.el-dialog .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 1);
}
</style>
